import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class EbDashboardAuthService {

  routePrefix = '/api/eb-dashboard-auth';
  requestTokenKey = 'requestToken';
  requestToken: string;
  constructor(private http: HttpClient) { }

  getRequestTokenHeader(): HttpHeaders {
    this.requestToken = sessionStorage.getItem(this.requestTokenKey);
    return new HttpHeaders().set(this.requestTokenKey, this.requestToken);
  }

  generateOtp(
    groupPolicyNo: string,
    birthYear: number,
    certificateNo: string,
    recaptcha: string,
  ): Observable<any> {
    const body = {
      groupPolicyNumber: groupPolicyNo.toString(),
      birthYear: birthYear,
      certificateNumber: certificateNo.toString(),
      recaptcha: recaptcha,
    };
    return this.http.post(this.routePrefix+ "/generate-otp", body);
  }

  otpValidation(otp: string, enrolId: number): Observable<any> {
    const body = {
      otp: otp,
      enrolId: enrolId
    };
    return this.http.post(this.routePrefix+ "/validate-otp", body, { headers: this.getRequestTokenHeader() });
  }
}
